import tw, { styled } from 'twin.macro';

const StyledInput = styled.input<{ fullWidth?: boolean; disabled?: boolean }>`
  ${tw`appearance-none block px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`};
  ${(props) => (props.fullWidth ? tw`w-full` : tw`w-3/4`)}
  ${(props) => (props.disabled ? tw`bg-gray-300 text-gray-700` : '')}
`;

export default StyledInput;
